import { queryOptions } from '@tanstack/react-query'
import { packageApi } from 'api/packageApi'
import _ from 'lodash'

export const queryKeys = {
  base: {
    scope: ['packages', 'getDurationPackages'],
    entity: 'package',
  },
  getDurationPackages: (params) =>
    queryOptions({
      queryKey: [queryKeys.base, params],
      queryFn: ({ signal }) => {
        return packageApi.getDurationPackages(params, signal)
      },
      staleTime: 1000 * 60,
      refetchOnWindowFocus: true,
      retry: false,
      select: (res) => {
        console.log(res)
        return {
          total: _.get(res, 'count', 0),
          rows: _.get(res, 'packages', []),
        }
      },
    }),
}
